/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smart_SelectInputs */

const en_smart_select = /** @type {(inputs: Smart_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smart Select`)
};

const fr_smart_select = /** @type {(inputs: Smart_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélection intelligente`)
};

const de_smart_select = /** @type {(inputs: Smart_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smart Select`)
};

const it_smart_select = /** @type {(inputs: Smart_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selezione intelligente`)
};

const ru_smart_select = /** @type {(inputs: Smart_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smart Select`)
};

const es_smart_select = /** @type {(inputs: Smart_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selección inteligente`)
};

const zh_cn2_smart_select = /** @type {(inputs: Smart_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`智能选择`)
};

const ja_smart_select = /** @type {(inputs: Smart_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スマートセレクト`)
};

const hi_smart_select = /** @type {(inputs: Smart_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्मार्ट सेलेक्ट`)
};

const pt_pt2_smart_select = /** @type {(inputs: Smart_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleção Inteligente`)
};

/**
* | output |
* | --- |
* | "Smart Select" |
*
* @param {Smart_SelectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const smart_select = /** @type {((inputs?: Smart_SelectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smart_SelectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_smart_select(inputs)
	if (locale === "de") return de_smart_select(inputs)
	if (locale === "it") return it_smart_select(inputs)
	if (locale === "ru") return ru_smart_select(inputs)
	if (locale === "es") return es_smart_select(inputs)
	if (locale === "zh-CN") return zh_cn2_smart_select(inputs)
	if (locale === "ja") return ja_smart_select(inputs)
	if (locale === "hi") return hi_smart_select(inputs)
	if (locale === "pt-PT") return pt_pt2_smart_select(inputs)
	return en_smart_select(inputs)
});